import React, { createContext, useContext, useState } from 'react';

const CurrencyContext = createContext();

export const useCurrency = () => {
    const context = useContext(CurrencyContext);
    if (!context) {
        throw new Error('useCurrency must be used within a CurrencyProvider');
    }
    return context;
};

export const CurrencyProvider = ({ children }) => {
    const [currency, setCurrency] = useState('CDF');
    const [date, setDate] = useState('');
    const [totalSolde, setTotalSolde] = useState(0);
    const [specificSolde, setSpecificSolde] = useState(0);

    return (
        <CurrencyContext.Provider
            value={{
                currency,
                setCurrency,
                date,
                setDate,
                totalSolde,
                setTotalSolde,
                specificSolde,
                setSpecificSolde
            }}
        >
            {children}
        </CurrencyContext.Provider>
    );
};

